import { MyProfile as MyProfileV2 } from '../../../../V2/pages/myProfile/MyProfile';
import MyProfile from './Pages/MyProfile/MyProfile';

export const DynamicComponent = ({ isSplitTest }) => {
  return isSplitTest ? <MyProfile /> : <MyProfileV2 />;
};
